export default () => ({
	contact: {
		marginTop: 22,
	},
	empty: {
		minHeight: 157,
	},
});
